import { LayoutPageSectionShell } from 'components/authorable/layout/LayoutPageSection/LayoutPageSection';
import { LayoutLeftThirdShell } from 'components/authorable/layout/LayoutLeftThird/LayoutLeftThird';
import AnnouncementStats from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/Announcement/AnnouncementStats';
import { classnames } from 'tailwindcss-classnames';
import FeeScheduleResults from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/FeeSchedule/FeeScheduleResults';
import FeeScheduleFacets from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/FeeSchedule/FeeScheduleFacets';
import { Autocomplete } from 'components/helpers/AlgoliaSearch/Autocomplete';
import SearchSort from 'components/helpers/AlgoliaSearch/SearchSort';
import useDictionary from 'lib/sitecore/use-dictionary';

export interface FeeScheduleProps {
  fields?: {};
}

const FeeSchedule = (): JSX.Element => {
  const dictionary = useDictionary();
  const Placeholdertext = dictionary.Search_Input_Fee_Schedules;

  return (
    <LayoutPageSectionShell theme="theme-white">
      <div className="schedules-reports md:px-20">
        <div className={classnames('w-full', 'pl-4', 'md:pl-0', 'pb-7', 'lg:pb-0')}>
          <AnnouncementStats />
        </div>
        <div
          className={classnames(
            'flex',
            'flex-col',
            'justify-between',
            'items-center',
            'w-full',
            'pb-1',
            'lg:flex-row',
            'mt-4',
            'xl:mt-0',
            'xl:py-0'
          )}
        >
          <span className={classnames('relative', 'p-0', 'xl:bg-none', 'xl:pr-0', 'w-full')}>
            <Autocomplete
              detachedMediaQuery="none"
              openOnFocus
              asSearchBox
              placeholder={Placeholdertext}
              className={classnames(
                'flex',
                'flex-col',
                'md:items-center',
                'justify-between',
                'pb-6',
                'md:flex-row',
                'lg:pt-4',
                'lg:pb-2',
                'w-auto',
                'lg:w-full',
                'mb-4',
                'lg:mb-0',
                'lg:mx-0'
              )}
            />
          </span>
          <span className={classnames('hidden', 'lg:block')}>
            <SearchSort profile="fee-schedule" />
          </span>
        </div>
        <LayoutLeftThirdShell
          left={<FeeScheduleFacets />}
          right={<FeeScheduleResults />}
          isSearchPage
        />
      </div>
    </LayoutPageSectionShell>
  );
};

export default FeeSchedule;
